module.exports = __webpack_public_path__ + "img/Lean Lab Logo - Hitam-01.3650cba2.png";